import { WiDaySunny } from "react-icons/wi";
import { RiMoonLine } from "react-icons/ri";
import { CiMonitor } from "react-icons/ci";
import { motion, AnimatePresence } from "framer-motion";

import { useTheme } from "@/providers/theme-provider";

type Theme = "dark" | "light" | "system";

const THEMES = ["light", "dark", "system"];

export const ThemeToggle = () => {
  const { setTheme, theme } = useTheme();

  const handleChangeTheme = () => {
    const currentThemeIndex = THEMES.findIndex((t) => t === theme);
    const nextThemeIndex = (currentThemeIndex + 1) % THEMES.length;

    const nextTheme = THEMES[nextThemeIndex] as Theme;
    setTheme(nextTheme);
  };

  return (
    <button
      className="p-[5px] rounded-md transition-all duration-300 hover:bg-ring/10"
      onClick={handleChangeTheme}
    >
      <AnimatePresence>
        {theme === "light" && (
          <motion.span
            initial={{
              scale: 0,
            }}
            animate={{
              scale: 1,
              transition: {
                duration: 1,
              },
            }}
            exit={{
              scale: 0,
            }}
          >
            <WiDaySunny className="w-6 h-6" />
          </motion.span>
        )}
        {theme === "dark" && (
          <motion.span
            initial={{
              scale: 0,
            }}
            animate={{
              scale: 1,
              transition: {
                duration: 1,
              },
            }}
            exit={{
              scale: 0,
            }}
          >
            <RiMoonLine className="w-5 h-5" />
          </motion.span>
        )}
        {theme === "system" && (
          <motion.span
            initial={{
              scale: 0,
            }}
            animate={{
              scale: 1,
              transition: {
                duration: 1,
              },
            }}
            exit={{
              scale: 0,
            }}
          >
            <CiMonitor className="w-5 h-5" />
          </motion.span>
        )}
      </AnimatePresence>
    </button>
  );
};
